import { render } from "./InputCheckboxes.vue?vue&type=template&id=47717a59"
import script from "./InputCheckboxes.vue?vue&type=script&lang=ts"
export * from "./InputCheckboxes.vue?vue&type=script&lang=ts"
script.render = render

export default script